<template>
  <section>
    <div v-if="user">
      <v-btn @click="logout()" type="button" color="secondary">Logout</v-btn>
    </div>
    <!-- <v-btn :disabled="user" color="primary" @click="login()" type="button" v-if="!user"> Login </v-btn> -->
    <!-- <v-btn :disabled="user" large outlined @click="login()" type="button" v-if="!user" style="text-transform: none !important">
      <img src="../assets/g-logo.svg" alt="" srcset="" style="vertical-align: middle; padding-right: 24px" />
      Anmelden mit Google
    </v-btn> -->
  </section>
</template>

<script>
export default {
  name: "Login",
  props: ["user"],
  data: function () {
    return {};
  },
  methods: {
    login() {
      this.$emit("login");
    },
    logout() {
      this.$emit("logout");
    },
  },
};
</script>

<style></style>
